// 请求栈
export default class Stack {
	list = {}
	willDelRequest = []
	delTimer = null
	timerDelay = 300

	getUrlName(url) {
		const urlArr = url.split('?')[0].split('/')
		const urlName = urlArr[urlArr.length - 1]
		return urlName
	}

	append(config, options = {}) {
		const urlName = this.getUrlName(config.url)

		// 如果目前栈内已有的请求，禁止重复请求
		if (this.list[urlName]) {
			options.requestAbout.abort()
			return this
		}

		this.list[urlName] = { options, config }
		return this
	}

	remove(config) {
		const _this = this
		const urlName = this.getUrlName(config.url)

		this.delTimer && this.clearDelTimer()
		this.willDelRequest.push(urlName)
		this.delTimer = setTimeout(() => {
			_this.willDelRequest.forEach(item => delete _this.list[item])
			_this.willDelRequest = []
			_this.clearDelTimer()
		}, this.timerDelay)

		return this
	}

	clearDelTimer () {
		clearTimeout(this.delTimer)
		this.delTimer = null
	}

	// 全部请求取消
	abortAll() {
		Object.values(this.list).forEach(item => {
			item.options.requestAbout.abort()
		})
		return this
	}

	getNumber() {
		return Object.values(this.list).length
	}

	isEmpty() {
		return !this.getNumber()
	}

	clear() {
		this.list = {}
	}
}
